import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  CheckBox,
  FormHeader,
  ImageComponent,
  InputBox,
  Uploader,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";

import Scrollbars from "react-custom-scrollbars-2";
import AdvertismentSelectBox from "../../templates/advertisementSelectBox";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectNews } from "../../news/redux/actions";
import { Store } from "react-notifications-component";
import {
  createNewAdvertisement,
  updateAdvertisement,
} from "./service/advertisement.service";
import moment from "moment";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";
import { message } from "antd";
import { clearedSelectItems } from "../../advertisement/redux/actions";
import WebBannerUploader from "../../../components/webBannerUploader";

const CreateNewAdvertisement = (props) => {
  const dispatch = useDispatch();
  const selectCampaign = useSelector(
    (state) => state.advertismentReducer.selectCampaign,
  );
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [finish, setFinish] = useState(true);
  const [useLanguage, setUseLanguage] = useState("si");
  const [formData, setFormData] = useState({
    campaignName: {
      key: "campaignName",
      label: "Campaign Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [{ value: "", displayValue: "-- Select Category --" }],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    subCategory: {
      key: "subCategory",
      label: "Sub Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [{ value: "", displayValue: "-- Select Category --" }],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    webUrl: {
      key: "webUrl",
      label: "Web URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    title: {
      key: "title",
      label: "Title",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    description: {
      key: "description",
      label: "Description",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    buttonType: {
      key: "buttonType",
      label: "Button Type",
      size: "sm",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [
          {
            key: "More",
            displayValue: "More",
          },
          {
            key: "Learn More",
            displayValue: "Learn More",
          },
          {
            key: "Click",
            displayValue: "Click",
          },
          {
            key: "Visit",
            displayValue: "Visit",
          },
        ],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [images, setImages] = useState([]);
  const [rightImage, setRightImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [banner, setBanner] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [gifImageRight, setGifImageRight] = useState(null);
  const [logoImage, setLogoImage] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [previewImagesRight, setPreviewImagesRight] = useState([]);
  const [gifImage, setGifImage] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const MAX_IMAGES = 4;
  const MAX_IMAGES_RIGHT = 4;

  const [placementType, setPlacementType] = useState({
    home: false,
    inner: false,
  });

  const [adSpaceType, setAdSpaceType] = useState({
    header: false,
    right: false,
  });

  const [scheduleTime, setScheduleTime] = useState({
    continuously: false,
    sevenDays: false,
    thirtyDays: false,
    oneTwentyEightDays: false,
  });

  const handleChange = async (event, inputIdentity) => {
    const updateAdvertisementForm = {
      ...formData,
    };

    updateAdvertisementForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateAdvertisementForm[inputIdentity].value,
      updateAdvertisementForm[inputIdentity].validation,
    );

    if (validityRes) {
      updateAdvertisementForm[inputIdentity].isValid = validityRes.isValid;
      updateAdvertisementForm[inputIdentity].invalidReason = validityRes.reason;
      updateAdvertisementForm[inputIdentity].value = event;
      updateAdvertisementForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateAdvertisementForm) {
        formIsValid =
          updateAdvertisementForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateAdvertisementForm);
    }
  };

  const clearAll = () => {
    const updateAdvertisementForm = {
      ...formData,
    };
    for (let key in updateAdvertisementForm) {
      updateAdvertisementForm[key].value = "";
      updateAdvertisementForm[key].isValid = false;
      updateAdvertisementForm[key].touched = false;
    }
    setImages([]);
    setRightImage([]);
    setLogoImage("");
    setBannerImage(null);
    setGifImage(null);
    setGifImageRight(null);
    setPlacementType({
      home: false,
      inner: false,
    });
    setAdSpaceType({
      header: false,
      right: false,
    });
    setScheduleTime({
      continuously: false,
      sevenDays: false,
      thirtyDays: false,
      oneTwentyEightDays: false,
    });

    setFinish(true);
    dispatch(clearedSelectItems());
    setFormData(updateAdvertisementForm);
  };

  const updateAdvertisementForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    if (selectCampaign?.advertisement_id) {
      console.log("id", selectCampaign?.advertisement_id);
      const updateAdvertisementForm = {
        ...formData,
      };
      updateAdvertisementForm.campaignName.value = selectCampaign?.campaignName;
      if (selectCampaign?.category) {
        console.log("category", selectCampaign);
        updateAdvertisementForm.category.value = selectCampaign?.category;
        updateAdvertisementForm.category.isValid = true;
        updateAdvertisementForm.category.touched = true;
      }
      // updateAdvertisementForm.category.value = selectCampaign?.category;
      updateAdvertisementForm.subCategory.value = selectCampaign?.subCategory;
      updateAdvertisementForm.webUrl.value = selectCampaign?.web_url;
      updateAdvertisementForm.title.value = selectCampaign?.title;
      updateAdvertisementForm.description.value = selectCampaign?.description;
      updateAdvertisementForm.buttonType.value = selectCampaign?.button_type;
      if (Array.isArray(selectCampaign?.header_banner_img)) {
        setImages(selectCampaign?.header_banner_img);
      } else if (selectCampaign?.header_banner_img) {
        setImages([{ file_name: "", url: selectCampaign?.header_banner_img }]);
      } else {
        setImages([]);
      }

      if (Array.isArray(selectCampaign?.right_banner_img)) {
        setRightImage(selectCampaign?.right_banner_img);
      } else if (selectCampaign?.right_banner_img) {
        setRightImage([
          { file_name: "", url: selectCampaign?.right_banner_img },
        ]);
      } else {
        setRightImage([]);
      }
      setPlacementType({
        home: selectCampaign?.placement?.home,
        inner: selectCampaign?.placement?.inner,
      });
      setAdSpaceType({
        header: selectCampaign?.ad_space?.header,
        right: selectCampaign?.ad_space?.right,
      });
      setScheduleTime({
        continuously: selectCampaign?.time_schedule?.continuously || false,
        sevenDays: selectCampaign?.time_schedule?.sevenDays,
        thirtyDays: selectCampaign?.time_schedule?.thirtyDays,
        oneTwentyEightDays: selectCampaign?.time_schedule?.oneTwentyEightDays,
      });

      // setScheduleTime(selectCampaign.time_schedule);
      // console.log("scheduleTime", selectCampaign?.time_schedule);
      setFormData(updateAdvertisementForm);
    } else {
      for (let key in updateAdvertisementForm) {
        // console.log(updateAdvertisementForm[key]);
        updateAdvertisementForm[key].value = "";
        updateAdvertisementForm[key].isValid = false;
        updateAdvertisementForm[key].touched = false;
      }
      setImages([]);
      setRightImage([]);
      setLogoImage("");
      setBannerImage(null);
      setGifImage(null);
      setGifImageRight(null);
      setPlacementType({
        home: false,
        inner: false,
      });
      setAdSpaceType({
        header: false,
        right: false,
      });
      setScheduleTime({
        continuously: false,
        sevenDays: false,
        thirtyDays: false,
        oneTwentyEightDays: false,
      });
      setFinish(true);
      setFormData(updateAdvertisementForm);
    }
  }, [selectCampaign]);

  const categorySelect = (value) => {
    console.log({ value });
    const updateAdvertisementForm = { ...formData };
    updateAdvertisementForm["category"].value = value?.id;
    updateAdvertisementForm["subCategory"].value = value?.key;
    setFormData(updateAdvertisementForm);
  };

  const onChangeImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          file_name: image.file_name,
        };
        // setImages([...image, file]);
        setImages((prev) => [...prev, file].slice(0, MAX_IMAGES));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onChangeRightImage = (rightImage) => {
    try {
      if (rightImage) {
        let file = {
          url: rightImage.file_url,
          file_name: rightImage.file_name,
        };
        // setRightImage(file);
        setRightImage((prev) => [...prev, file].slice(0, MAX_IMAGES_RIGHT));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onClickRemoveImage = async (key, type, index) => {
    try {
      const RemoveImage = await deleteImage(key);
      console.log("remove image", RemoveImage);
      if (RemoveImage.data.status) {
        console.log("Image Deleted");
        if (type === "right") {
          setRightImage((prev) => prev.filter((_, i) => i !== index));
        } else {
          setImages((prev) => prev.filter((_, i) => i !== index));
        }

        message.success("Image Deleted");
      } else {
        console.log("Deleted Fail");
      }
    } catch (error) {
      console.log("Error in deleting image", error);
      message.error("Error in deleting image");
    }
  };

  useEffect(() => {
    clearAll();
    dispatch(clearSelectNews());
  }, []);

  const handleImage = (list) => {
    if (list?.length > 0) {
      setImages(list);
    } else {
      setImages([]);
    }
  };

  const handleImageRight = (list) => {
    if (list?.length > 0) {
      setRightImage(list);
    } else {
      setRightImage([]);
    }
  };

  const handleTab = (tab) => {
    if (tab) {
      setBanner(tab);
    }
  };
  const handleGif = (image) => {
    setGifImage(image);
  };

  const onChangeUrl = (form) => {
    if (form) {
      setFormData({
        ...formData,
        destinationURL: form.destinationURL,
        title: form.title,
        description: form.description,
        buttonType: form.buttonType,
      });
      // setFinish(false);
    }
  };

  const handleBannerImage = (image) => {
    setBannerImage(image);
  };

  const handleLogo = (image) => {
    setLogoImage(image);
  };

  const handleGifRight = (image) => {
    setGifImageRight(image);
  };

  // const buildTimeSchedule = (selected) => ({
  //   sevenDays: selected === "sevenDays",
  //   thirtyDays: selected === "thirtyDays",
  //   oneTwentyEightDays: selected === "oneTwentyEightDays",
  // });

  const scheduleTimeMap = {
    sevenDays: 7,
    thirtyDays: 30,
    oneTwentyEightDays: 128,
  };

  const onClickPublish = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);
    const updateAdvertisementForm = { ...formData };

    const daysToAdd = scheduleTime.sevenDays
      ? 7
      : scheduleTime.thirtyDays
        ? 30
        : scheduleTime.oneTwentyEightDays
          ? 128
          : 0;

    try {
      const response = await createNewAdvertisement({
        campaignName: updateAdvertisementForm.campaignName.value,
        // category: updateAdvertisementForm.category.value ,
        category: [
          {
            category_id: updateAdvertisementForm.category.value,
            sub_category_id: updateAdvertisementForm.subCategory.value,
          },
        ],
        subCategory: updateAdvertisementForm.subCategory.value || "",
        placement: placementType,
        ad_space: adSpaceType,
        time_schedule: scheduleTime,
        header_banner_img: images.length > 0 ? images : [],
        right_banner_img: rightImage.length > 0 ? rightImage : [],
        text_banner_logo: logoImage?.url || "",
        text_banner_img: bannerImage ? [bannerImage] : [],
        header_gif: gifImage ? [gifImage] : [],
        right_gif: gifImageRight ? [gifImageRight] : [],
        title: updateAdvertisementForm.title.value || "",
        description: updateAdvertisementForm.description.value || "",
        button_type: updateAdvertisementForm.buttonType.value || "",

        web_url: updateAdvertisementForm.webUrl.value || "",
        start_date: moment().format("DD-MM-YYYY"),
        // end_date: new Date(now.getTime() + daysToAdd * 24 * 60 * 60 * 1000),
        end_date: moment().add(daysToAdd, "days").format("DD-MM-YYYY"),
      });
      console.log("response", response);
      setIsLoading(false);
      if (response?.data) {
        // dispatch(addList(response?.data));
        Store.addNotification({
          title: "Success!",
          message: "Advertisment Create Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        props.setRefresh(true);
        clearAll();
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error ===", error);
      Store.addNotification({
        title: "Error!",
        message: "Advertisment Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);
    const updateAdvertisementForm = { ...formData };

    const daysToAdd = scheduleTime.sevenDays
      ? 7
      : scheduleTime.thirtyDays
        ? 30
        : scheduleTime.oneTwentyEightDays
          ? 128
          : 0;

    try {
      const response = await updateAdvertisement(
        {
          campaignName: updateAdvertisementForm.campaignName.value,
          // category: updateAdvertisementForm.category.value,
          category: [
            {
              category_id: selectCampaign?.category?.[0]?.category_id,
              sub_category_id: updateAdvertisementForm.subCategory.value,
            },
          ],
          subCategory: updateAdvertisementForm.subCategory.value || "",
          placement: placementType,
          ad_space: adSpaceType,
          time_schedule: scheduleTime,
          header_banner_img: images.length > 0 ? images : [],
          right_banner_img: rightImage.length > 0 ? rightImage : [],
          text_banner_logo: logoImage?.url || "",
          text_banner_img: bannerImage ? [bannerImage] : [],
          header_gif: gifImage ? [gifImage] : [],
          right_gif: gifImageRight ? [gifImageRight] : [],
          title: updateAdvertisementForm.title.value || "",
          description: updateAdvertisementForm.description.value || "",
          button_type: updateAdvertisementForm.buttonType.value || "",

          web_url: updateAdvertisementForm.webUrl.value || "",
          start_date: moment().format("DD-MM-YYYY"),
          end_date: moment().add(daysToAdd, "days").format("DD-MM-YYYY"),
        },
        selectCampaign?.advertisement_id,
      );
      console.log("update response", response);
      setIsLoading(false);
      if (response?.data) {
        // dispatch(addList(response?.data));
        Store.addNotification({
          title: "Success!",
          message: "Advertisment Update Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        props.setRefresh(true);
        clearAll();
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error ===", error);
      Store.addNotification({
        title: "Error!",
        message: "Advertisment Update Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
    }
  };

  return (
    <>
      <div className="hne-create-advertisement-wrapper pl-3 pr-3">
        <FormHeader
          data={{
            formHeader: "Create New Advertisement",
            size: "md-md",
          }}
        />
        <Scrollbars
          onScroll={handleOnScroll}
          renderView={(props) => (
            <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
          )}
          style={{ height: viewPointHeight - 300 }}
        >
          <div
            style={{
              paddingBottom: "42px",
              paddingRight: "16px",
            }}
          >
            <>
              <InputBox
                data={updateAdvertisementForm.campaignName}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateAdvertisementForm.campaignName.key,
                  );
                }}
              />

              <AdvertismentSelectBox
                onChangeCategory={categorySelect}
                data={{
                  type: "subCategory",
                }}
              />
            </>

            <div className={"hne-body-title "}>Select Your Ad Spaces</div>

            <div className={"selector-lable"}>Ad Placement Page</div>
            <div className="hne-adv-select-box-wrapper">
              <CheckBox
                data={{
                  checkName: "Home page",
                  isActive: placementType.home,
                }}
                onClick={() => {
                  setPlacementType((prev) => ({ ...prev, home: !prev.home }));
                }}
              />

              <CheckBox
                data={{
                  checkName: "Inner page",
                  isActive: placementType.inner,
                }}
                onClick={() => {
                  setPlacementType((prev) => ({
                    ...prev,
                    inner: !prev.inner,
                  }));
                }}
              />
            </div>

            <div className={"selector-lable"}>Choose Ad Spaces</div>
            <div className="hne-adv-select-box-wrapper ">
              <CheckBox
                data={{
                  checkName: "Header",
                  isActive: adSpaceType.header,
                }}
                onClick={() => {
                  setAdSpaceType((prev) => ({
                    ...prev,
                    header: !prev.header,
                  }));
                }}
              />

              <CheckBox
                data={{
                  checkName: "Right bar",
                  isActive: adSpaceType.right,
                }}
                onClick={() => {
                  setAdSpaceType((prev) => ({
                    ...prev,
                    right: !prev.right,
                  }));
                }}
              />
            </div>
            {/* {adSpaceType.header && (
              <div className="hne-advertisement-header-bar-wrapper"> */}
            {/* <div className="ahbw-title">
                  Upload Header Advertisement Image
                </div> */}

            {/* Render uploaded images */}
            {/* {images?.length > 0 &&
                  images?.map((img, index) => (
                    <ImageComponent
                      key={index}
                      data={{ size: "header-ad mb-2", imgUrl: img.url }}
                      onClickRemove={() =>
                        onClickRemoveImage(img?.file_name, "header", index)
                      }
                    />
                  ))} */}

            {/* Render placeholders for remaining slots */}
            {/* <div className={"image-grid-wrapper"}>
                  {Array.from({ length: MAX_IMAGES - images?.length }).map(
                    (_, index) => (
                      <div
                        key={`placeholder-${index}`}
                        className="header-bar-adv-wrapper flex items-center justify-center text-gray-400"
                      >
                        Advertisement with us
                      </div>
                    )
                  )}
                </div> */}

            {/* Only show uploader if there's room */}
            {/* {images?.length < MAX_IMAGES && (
                  <Uploader
                    data={{
                      disabled: false,
                      isLable: true,
                      iconName: "upload-cloud",
                    }}
                    onChange={onChangeImage}
                  />
                )} */}

            {/* ----------------------------- */}
            {/*{image && (*/}
            {/*  <>*/}
            {/*    <ImageComponent*/}
            {/*      data={{ size: "header-ad mb-2", imgUrl: image?.url }}*/}
            {/*      onClickRemove={() => {*/}
            {/*        if (selectCampaign?.advertisement_id) {*/}
            {/*          setImages("");*/}
            {/*        } else {*/}
            {/*          onClickRemoveImage(image?.file_name, "header");*/}
            {/*        }*/}
            {/*      }}*/}
            {/*    />*/}
            {/*  </>*/}
            {/*)}*/}
            {/*{!image && (*/}
            {/*  <Uploader*/}
            {/*    data={{*/}
            {/*      disabled: false,*/}
            {/*      isLable: true,*/}
            {/*      iconName: "upload-cloud",*/}
            {/*    }}*/}
            {/*    onChange={onChangeImage}*/}
            {/*  />*/}
            {/*)}*/}
            {/* <div className="aiw-sub-title">728x90 pixels</div> */}
            {/* </div>
            )} */}

            {adSpaceType.header && (
              <div className="hne-advertisement-header-bar-wrapper">
                <WebBannerUploader
                  data={{
                    title: "Upload Header Advertisement Image",
                    type: "header",
                    isAdmin: true,
                  }}
                  setImageList={handleImage}
                  setImageListRight={handleImageRight}
                  onChange={onChangeUrl}
                  setTabName={handleTab}
                  setGif={handleGif}
                />
              </div>
            )}

            {/* {adSpaceType.right && (
              <div className="hne-advertisement-image-wrapper">
                <div className="ahbw-title">Upload Right bar adv</div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "14px",
                    alignItems: "center",
                  }}
                > */}
            {/* Render uploaded images */}
            {/* {rightImage?.length > 0 &&
                    rightImage?.map((img, index) => (
                      <ImageComponent
                        key={index}
                        data={{ size: "right-adv mb-2", imgUrl: img.url }}
                        onClickRemove={() =>
                          onClickRemoveImage(img?.file_name, "right", index)
                        }
                      />
                    ))} */}

            {/* Render placeholders for remaining slots */}
            {/* <div className={"image-grid-wrapper"}>
                    {Array.from({
                      length: MAX_IMAGES_RIGHT - rightImage?.length,
                    }).map((_, index) => (
                      <div
                        key={`placeholder-${index}`}
                        className="right-bar-adv-wrapper flex items-center justify-center text-gray-400"
                      >
                        Advertisement with us
                      </div>
                    ))}
                  </div> */}

            {/* Only show uploader if there's room */}
            {/* {rightImage?.length < MAX_IMAGES_RIGHT && (
                    <Uploader
                      data={{
                        disabled: false,
                        isLable: true,
                        iconName: "upload-cloud",
                      }}
                      onChange={onChangeRightImage}
                    />
                  )} */}

            {/* --------------------------------------- */}
            {/*{!rightImage && (*/}
            {/*  <div className="right-bar-adv-wrapper">*/}
            {/*    Advertisement with us*/}
            {/*  </div>*/}
            {/*)}*/}
            {/*{rightImage && (*/}
            {/*  <>*/}
            {/*    <ImageComponent*/}
            {/*      data={{*/}
            {/*        size: "right-ad mb-2",*/}
            {/*        imgUrl: rightImage?.url,*/}
            {/*      }}*/}
            {/*      onClickRemove={() => {*/}
            {/*        if (selectCampaign?.advertisement_id) {*/}
            {/*          setRightImage("");*/}
            {/*        } else {*/}
            {/*          onClickRemoveImage(rightImage?.file_name, "right");*/}
            {/*        }*/}
            {/*      }}*/}
            {/*    />*/}
            {/*  </>*/}
            {/*)}*/}

            {/*{!rightImage && (*/}
            {/*  <Uploader*/}
            {/*    data={{*/}
            {/*      disabled: false,*/}
            {/*      isLable: true,*/}
            {/*      iconName: "upload-cloud",*/}
            {/*    }}*/}
            {/*    onChange={onChangeRightImage}*/}
            {/*  />*/}
            {/*)}*/}
            {/* </div>
                <div className="aiw-sub-title">620x620 pixels</div>
              </div>
            )} */}

            {adSpaceType.right && (
              <div className="hne-advertisement-image-wrapper">
                <WebBannerUploader
                  data={{
                    title: "Upload Right bar adv",
                    type: "slider",
                    isAdmin: true,
                  }}
                  setImageListRight={handleImageRight}
                  onChange={onChangeUrl}
                  setTabName={handleTab}
                  setLogo={handleLogo}
                  setBanner={handleBannerImage}
                  setGifRight={handleGifRight}
                />
              </div>
            )}

            <div className="d-flex flex-row align-items-center justify-content-between mb-3">
              <InputBox
                data={updateAdvertisementForm.webUrl}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateAdvertisementForm.webUrl.key,
                  );
                }}
              />
            </div>

            <div className="hne-advertistment-footer-wrapper">
              <div className={"selector-lable"}>Schedule Ad Timing</div>
              <div className="hne-adv-select-box-wrapper ">
                <CheckBox
                  data={{
                    checkName: "7 days",
                    isActive: scheduleTime.sevenDays,
                  }}
                  onClick={() => {
                    setScheduleTime((prev) => ({
                      sevenDays: !prev.sevenDays,
                      thirtyDays: false,
                      oneTwentyEightDays: false,
                      continuously: false,
                    }));
                  }}
                />

                <CheckBox
                  data={{
                    checkName: "30 days",
                    isActive: scheduleTime.thirtyDays,
                  }}
                  onClick={() => {
                    setScheduleTime((prev) => ({
                      sevenDays: false,
                      thirtyDays: !prev.thirtyDays,
                      oneTwentyEightDays: false,
                      continuously: false,
                    }));
                  }}
                />
                <CheckBox
                  data={{
                    checkName: "128 days",
                    isActive: scheduleTime.oneTwentyEightDays,
                  }}
                  onClick={() => {
                    setScheduleTime((prev) => ({
                      sevenDays: false,
                      thirtyDays: false,
                      oneTwentyEightDays: !prev.oneTwentyEightDays,
                      continuously: false,
                    }));
                  }}
                />
                <CheckBox
                  data={{
                    checkName: "Continuously",
                    isActive: scheduleTime.continuously,
                  }}
                  onClick={() => {
                    setScheduleTime((prev) => ({
                      sevenDays: false,
                      thirtyDays: false,
                      oneTwentyEightDays: false,
                      continuously: !prev.continuously,
                    }));
                  }}
                />
              </div>

              {scheduleTime?.sevenDays && (
                <div className="pw-price">Rs.2,500.00</div>
              )}
              {scheduleTime?.thirtyDays && (
                <div className="pw-price">Rs.10,000.00</div>
              )}
              {scheduleTime?.oneTwentyEightDays && (
                <div className="pw-price">Rs.35,000.00</div>
              )}
            </div>
          </div>
        </Scrollbars>
        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {selectCampaign?.advertisement_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearedSelectItems());
                clearAll();
              }}
            />
          )}

          <Button
            data={{
              btnName: selectCampaign?.advertisement_id ? "UPDATE" : "PUBLISH",
              buttonType:
                updateAdvertisementForm.campaignName.value === "" ||
                updateAdvertisementForm.category.value === ""
                  ? "primary disabled"
                  : useLanguage === "multi"
                    ? "primary disabled"
                    : "primary",

              buttonSize: "lg",
              isLoading: isLoading,
              disable:
                updateAdvertisementForm.campaignName.value === "" ||
                updateAdvertisementForm.category.value === ""
                  ? true
                  : useLanguage === "multi"
                    ? true
                    : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectCampaign?.advertisement_id) {
                await onClickUpdate(e);
              } else {
                await onClickPublish(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(CreateNewAdvertisement);
